import axios from 'axios';

import {
  DEFAULT_CONTACT_NUMBERS_LOS,
  DEFAULT_CONTACT_NUMBERS_LMS,
  type ContactNumbers,
} from '@app/configs/contactNumbers';

export type ContactNumbersJourney = 'LOS' | 'LMS';

type ContactNumbersApiResponse = {
  callData?: string;
  waData?: string;
};

function getFallback(journey: ContactNumbersJourney): ContactNumbers {
  const fallback =
    journey === 'LOS' ? DEFAULT_CONTACT_NUMBERS_LOS : DEFAULT_CONTACT_NUMBERS_LMS;
  return fallback;
}

export async function fetchContactNumbers(opts: {
  journey: ContactNumbersJourney;
  platform?: string | null;
  overriddenTelephoneNumber?: string | null;
  overriddenWhatsappNumber?: string | null;
}): Promise<ContactNumbers> {
  const { journey, platform, overriddenTelephoneNumber, overriddenWhatsappNumber } = opts;

  const fallback = getFallback(journey);
  let result: ContactNumbers = {
    phoneNumber: fallback.phoneNumber,
    whatsappNumber: fallback.whatsappNumber,
  };

  try {
    const params = {
      source: journey,
      platformCode: platform && platform.length > 0 ? platform : 'VOLT_WEB_APP',
      ...(overriddenTelephoneNumber ? { overriddenTelephoneNumber } : {}),
      ...(overriddenWhatsappNumber ? { overriddenWhatsappNumber } : {}),
    };

    const res = await axios.get<ContactNumbersApiResponse>('/api/v1/contacts/all', {
      params,
    });

    result = {
      phoneNumber: res?.data?.callData ?? fallback.phoneNumber,
      whatsappNumber: res?.data?.waData ?? fallback.whatsappNumber,
    };
  } catch (error) {
    result = {
      phoneNumber: fallback.phoneNumber,
      whatsappNumber: fallback.whatsappNumber,
    };
  } finally {
    return result;
  }
}

